import axios from 'axios'
export default {
    GETDYNAMICCONTENTS ({ commit }, pageId) {
        return axios.get(`/registration/getPageContents/${pageId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setAllContents', {coll: data.payload.lstDynamicPageContents})
            } else {
                commit('setAllContents', {coll: null})
            }
        }, (err) => {
            commit('setAllContents', {coll: null})
            console.log('err ', err)
        })
    },
    GET_NEWS_RESOURCES ({ commit }) {
        return axios.get(`/home/getAllNewsResource`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setAllNewsResources', {coll: data.payload})
                // Get Featured Articles
                let featuredArticles = data.payload.filter(x => {
                    return x.resourceType === 1
                })
                if (featuredArticles && featuredArticles.length > 0) {
                    commit('setFAResources', {coll: featuredArticles})
                } else {
                    commit('setFAResources', {coll: null})
                }
                // Get Set the TONE Articles
                let setToneArticles = data.payload.filter(x => {
                    return x.resourceType === 2
                })
                if (setToneArticles && setToneArticles.length > 0) {
                    commit('setSTResources', {coll: setToneArticles})
                } else {
                    commit('setSTResources', {coll: null})
                }
                // Get Advertisement Boxes
                let setAdvertisement = data.payload.filter(x => {
                    return x.resourceType === 3
                })
                if (setAdvertisement && setAdvertisement.length > 0) {
                    commit('setABResources', {coll: setAdvertisement})
                } else {
                    commit('setABResources', {coll: null})
                }
            } else {
                commit('setAllNewsResources', {coll: null})
            }
        }, (err) => {
            commit('setAllContents', {coll: null})
            console.log('err ', err)
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/dynamiccontents/actions.js